import React from 'react'
import { Box, BoxProps } from '@chakra-ui/core'
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts'
import { randomColor } from '../../../../utils'
import { ChartProps } from './type'
import { STANDARD_GRAPH_HEIGHT } from './constants'
import { theme } from '../../../../theme'

type AreaChartProps = ChartProps & BoxProps

const AreaChartComponent: React.FC<AreaChartProps> = ({
  data,
  xKey,
  yKey,
  barColor = theme.colors.brand[400],
  randomizeColors,
  ...rest
}) => {
  const processedData = React.useMemo(() => {
    const results = data?.map((entry) => ({
      ...entry,
      fill: randomizeColors ? randomColor() : barColor
    }))
    return results
  }, [data, randomizeColors, barColor])

  return (
    <Box w="100%" h="100%" fontSize="xs" {...rest}>
      <ResponsiveContainer height={STANDARD_GRAPH_HEIGHT}>
        <AreaChart data={processedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} />
          <YAxis />
          <Tooltip />
          <Area type="monotone" dataKey={yKey} stroke={barColor} />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  )
}

export default AreaChartComponent
